<template>
    <v-container fluid>
        <v-row style="height: 100vh" class="d-flex align-center justify-center">
            <v-col>
                <div class="d-flex">
                    <h1>{{ $t('journalNotFound') }}</h1>
                    <v-icon large class="ml-3" color="#111111">fa-frown-open</v-icon>
                </div>
                <p class="mt-2 mb-10">{{ $t('sharedJournalNotFound') }}</p>
                <v-btn @click="goToDashboard">{{ $t('goToDashboard') }}</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "SharedNotFound",
        methods: {
            goToDashboard() {
                this.$router.push('/dashboard');
            },
        }
    }
</script>

<style scoped>

</style>


